/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_R1_IdentityInputs */

const tr_kvkkbasvuru_s2_r1_identity = /** @type {(inputs: Kvkkbasvuru_S2_R1_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-imza veya mobil imza ile imzalı`)
};

const en_kvkkbasvuru_s2_r1_identity = /** @type {(inputs: Kvkkbasvuru_S2_R1_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed with an e-signature or mobile signature`)
};

const de_kvkkbasvuru_s2_r1_identity = /** @type {(inputs: Kvkkbasvuru_S2_R1_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit E-Signatur oder mobiler Signatur unterzeichnet`)
};

const ru_kvkkbasvuru_s2_r1_identity = /** @type {(inputs: Kvkkbasvuru_S2_R1_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписано электронной или мобильной подписью`)
};

/**
* | output |
* | --- |
* | "Signed with an e-signature or mobile signature" |
*
* @param {Kvkkbasvuru_S2_R1_IdentityInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_r1_identity = /** @type {((inputs?: Kvkkbasvuru_S2_R1_IdentityInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_R1_IdentityInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_r1_identity(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_r1_identity(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_r1_identity(inputs)
	return tr_kvkkbasvuru_s2_r1_identity(inputs)
});